if (CryptoJS) {
  var { enc, AES, mode, pad } = CryptoJS;
}
import { getFormattedMoney } from "//ringconn.com/cdn/shop/t/192/assets/theme.js?v=122298825136020323051777378003";
// 常量定义
const CONSTANTS = {
  AES_KEY: "c4312b5bf6b2dabf3fe54396b8bfe7c0",
  respKey: "482a7567f75b83294277b9366ed2a773",
  DEFAULT_AMOUNT: "90",
  API_PATH: "/admin/order/RingPartExchangeCouponGet",
  GEN1_API_PATH: "/admin/order/RingPartExchangeCheckGen1",
  CLIENT_INFO: {
    languageCode: window?.ShopifyInfo?.language || "en",
  },
  "ringconntest.myshopify.com": {
    2099: "44607420072189",
    "3099JP": "45779124027645",
    3099: "45779124027645",
    4099: "46100545896701",
    JP4099: "46100545896701",
  },
  "ringconn.com": {
    2099: "47501231161652",
    3099: "48229182996788",
    "3099JP": "48229182996788",
    4099: "48494923481396",
  },
  "ringconn.jp": {
    JP3099: "46502331547822",
    "3099JP": "46502331547822",
    JP4099: "46502331547822",
  },
  "de.ringconn.com": {
    2099: "43083351326831",
    3099: "43083351392367",
    4099: "43083351523439",
  },
};
class TradeIn extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  // 初始化方法
  init() {
    // 初始化元素引用
    this.errorTips = window.checkingRule.errorTips;
    // this.selectDeviceBtn = this.querySelector(".trade-in-btn");
    // this.noTradeInBtn = this.querySelector(".no-trade-in");
    this.deviceList = this.querySelector(".device-list");
    this.customSelect = this.querySelector(".device_select");
    this.selectSelected = this.querySelector(".select-selected");
    this.selectItems = this.querySelector(".select-items");
    this.deviceVariant = this.querySelector(".device-variant");
    this.emailField = this.querySelector(".email-field");
    this.snField = this.querySelector(".sn-field");
    this.snSubmitBtn = this.querySelector(".sn-submit-btn");
    this.errorMessages = this.querySelector(".error-message");
    this.tradeInForm = this.querySelector(".trade-in-form");
    this.tradeInError = this.querySelector(".trade-in-error");
    this.successElement = this.querySelector(".trade-in-success");

    // 初始化 trade_drawer 引用
    this.trade_drawer = document.querySelector("x-drawer.trade_drawer");

    this.setupEventListeners();
  }

  // ===== 加密解密相关方法 =====

  encrypted(data) {
    const aesKey = enc.Utf8.parse(CONSTANTS.AES_KEY);
    const jsonStr = JSON.stringify(JSON.parse(JSON.stringify(data)));
    const base64Encoded = btoa(jsonStr);
    return this.aesEncrypt(base64Encoded, aesKey);
  }

  aesEncrypt(plaintext, key) {
    const encrypted = AES.encrypt(plaintext, key, {
      mode: mode.ECB,
      padding: pad.Pkcs7,
    });
    return encrypted.ciphertext.toString(enc.Base64);
  }

  decrypted(encryptedBase64) {
    const aesKey = enc.Utf8.parse(CONSTANTS.respKey);
    const decryptedBase64 = this.aesDecrypt(encryptedBase64, aesKey);
    const originalJson = atob(decryptedBase64);
    return JSON.parse(originalJson);
  }

  aesDecrypt(ciphertext, key) {
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: enc.Base64.parse(ciphertext),
    });
    const decrypted = AES.decrypt(cipherParams, key, {
      mode: mode.ECB,
      padding: pad.Pkcs7,
    });
    return decrypted.toString(enc.Utf8);
  }

  // ===== 事件处理相关方法 =====

  setupEventListeners() {
    // 设备选择按钮事件
    // this.selectDeviceBtn.addEventListener("click", () => this.toggleDeviceList(true));
    // this.noTradeInBtn.addEventListener("click", () => this.toggleDeviceList(false));

    // 下拉菜单事件
    this.setupDropdownEvents();

    // 表单输入事件
    this.setupFormEvents();
  }

  setupDropdownEvents() {
    this.selectSelected.addEventListener("click", () => this.customSelect.classList.toggle("active"));

    document.addEventListener("click", (e) => {
      if (!this.customSelect.contains(e.target)) this.customSelect.classList.remove("active");
    });

    // 选项点击事件
    this.selectItems.querySelectorAll(".select-item").forEach((item) => {
      item.addEventListener("click", () => {
        const { value, type, title, price, image } = item.dataset;
        this.clearinput();
        // 更新选中项的显示内容，添加图片效果
        this.selectSelected.innerHTML = "";
        // 创建设备图片元素
        if (image) {
          const imgElement = document.createElement("img");
          imgElement.src = image;
          imgElement.alt = title;
          imgElement.className = "selected-device-image";
          this.selectSelected.appendChild(imgElement);
        }

        // 创建设备信息容器
        const infoContainer = document.createElement("div");
        infoContainer.className = "selected-device-info";

        // 创建设备名称元素
        const nameElement = document.createElement("div");
        nameElement.className = "selected-device-name";
        nameElement.textContent = title;
        infoContainer.appendChild(nameElement);

        // 创建设备价格元素
        const priceElement = document.createElement("div");
        priceElement.className = "selected-device-price";
        priceElement.innerHTML = getFormattedMoney(price);
        infoContainer.appendChild(priceElement);

        this.selectSelected.appendChild(infoContainer);

        // 保存数据到dataset
        this.selectSelected.dataset.value = value;
        this.selectSelected.dataset.price = price;
        this.selectSelected.dataset.type = type; // 添加type属性

        // 关闭下拉菜单
        this.customSelect.classList.remove("active");

        // 处理设备选择
        this.handleDeviceSelect(type);
        const trade_Gen1 = document.querySelector(".trade_drawer_content .RingConn1");
        const trade_competitor = document.querySelector(".trade_drawer_content .competitor");
        const trade_competitor2 = document.querySelector(".drawer_tradein_content");
        if (type == 1) {
          trade_Gen1.style.display = "block";
          trade_competitor.style.display = "none";
          trade_competitor2.style.display = "none";
        } else {
          trade_competitor.style.display = "block";
          trade_competitor2.style.display = "grid";
          trade_Gen1.style.display = "none";
        }

        // 将所有item的unit颜色重置
        this.selectItems.querySelectorAll(".select-item").forEach((item) => {
          item.classList.remove("active");
        });

        // 设置当前选中item的unit颜色为#000
        item.classList.add("active");
      });
    });
  }
  setupFormEvents() {
    const emailInput = this.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.addEventListener("input", (e) => {
        // 实时验证邮箱格式
        this.validateEmail(e.target);
      });
    }

    const snInput = this.querySelector('input[name="trade_sn"]');
    if (snInput) {
      snInput.addEventListener("input", (e) => {
        // 实时验证 SN 格式
        if (!this.validateSN(e.target)) return;
        this.updateSubmitButtonState();
      });
    }

    if (this.snSubmitBtn) {
      this.snSubmitBtn.addEventListener("click", () => this.handleSubmit());
    }
  }
  toggleDeviceList(show) {
    if (show) {
      // this.selectDeviceBtn.classList.add("active");
      // this.noTradeInBtn.classList.remove("active");
      this.deviceList.classList.add("active");
      this.deviceList.style.display = "flex";
      const tradeinIdInput = this.querySelector('input[name="tradein-device"]');
      if (tradeinIdInput) {
        tradeinIdInput.value = "";
        tradeinIdInput.dataset.devicePrice = "";
      }
    } else {
      this.handleEditButtonClick();
      this.resetForm();
    }
    this.tradeInError.style.display = "none";
  }

  handleDeviceSelect(deviceValue) {
    // 重置设备变体状态
    this.resetDeviceVariant();
    if (!deviceValue) return;
    // 设置新的设备变体状态
    this.setDeviceVariant(deviceValue);

    // 查找并应用设备配置
    this.applyDeviceConfig(deviceValue);
    this.updateSubmitButtonState();
    document.dispatchEvent(new CustomEvent("tradein:change"));
  }

  resetDeviceVariant() {
    this.deviceVariant.style.display = "none";
    this.deviceVariant.removeAttribute("data-active");
  }

  setDeviceVariant(deviceValue) {
    this.deviceVariant.dataset.device = deviceValue;
    this.deviceVariant.style.display = "flex";
    this.deviceVariant.setAttribute("data-active", "true");
  }

  applyDeviceConfig(deviceValue) {
    const selectedDevice = window.checkingRule.childeList.find((device) => device.type == deviceValue);
    if (!selectedDevice) return;

    // 更新类型输入
    const typeInput = this.querySelector('input[name="type"]');
    if (typeInput) typeInput.value = selectedDevice.type;

    // 更新字段显示
    this.updateFieldVisibility(selectedDevice);
  }

  updateFieldVisibility(device) {
    if (this.emailField) {
      this.emailField.style.display = device.showEmail ? "block" : "none";
      this.snSubmitBtn.style.display = device.showEmail ? "none" : "flex";
      this.emailField.addEventListener("click", (e) => {
        this.emailField.querySelector(".input-field").classList.add("active");
      });
    }

    if (this.snField) {
      this.snField.style.display = device.showSn ? "block" : "none";
      const tips = (this.tips = this.snField.querySelector(".tips"));
      if (tips) tips.textContent = device.tips || "";
      this.snField.addEventListener("click", (e) => {
        this.snField.querySelector(".input-field").classList.add("active");
      });
    }
  }

  updateSubmitButtonState() {
    if (!this.snSubmitBtn) return;

    const emailField = this.querySelector(".email-field");
    const emailInput = this.querySelector('input[type="email"]');
    const snInput = this.querySelector('input[name="trade_sn"]');

    const isEmailValid = emailField.style.display === "none" || this.validateEmailFormat(emailInput);
    const isSnValid = snInput && snInput.value.trim();

    this.snSubmitBtn.disabled = !isEmailValid || !isSnValid;
  }

  // ===== API 交互方法 =====

  // 在 TradeIn 类中添加 open 方法
  open() {
    if (!this.trade_drawer) {
      console.error("Trade drawer not found");
      return;
    }

    const overlay = this.trade_drawer.shadowRoot.querySelector('div[part="overlay"]');
    if (overlay) {
      overlay.style.display = "block";
    }
    this.trade_drawer.show();
    this.trade_drawer.setAttribute("open", "");

    // 设置垂直居中
    const height = this.trade_drawer.offsetHeight;
    const type = this.querySelector('.trade-in-form input[name="type"]').value || 1;
    this.trade_drawer.style.top = `0`;
  }

  // 修改 handleSubmit 方法
  async handleSubmit() {
    if (this.selectSelected.dataset.type == 1) {
      this.tradeInError.style.display = "none";
      const isPass = await this.submitTradeInForGen1();
      if (!isPass) return;
    }
    // 打开弹窗而不是直接提交
    this.open();
    this.tradeInError.style.display = "none";
    // 获取弹窗中的提交按钮并添加事件监听
    if (!this.trade_drawer) return;

    const submitButton = this.trade_drawer.querySelector(".trade_button");

    if (submitButton) {
      // 移除之前可能存在的事件监听
      submitButton.replaceWith(submitButton.cloneNode(true));
      const newSubmitButton = this.trade_drawer.querySelector(".trade_button");

      // 添加新的事件监听
      newSubmitButton.addEventListener("click", () => {
        this.submitTradeInForm();
      });
    }

    // 获取关闭按钮并添加事件监听
    const closeButton = this.trade_drawer.querySelector('button[part="close-button"]');
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        this.trade_drawer.removeAttribute("open");
      });
    }
  }

  // gen1 接口调用提前
  async submitTradeInForGen1() {
    this.snSubmitBtn.disabled = true;
    const formData = this.collectFormData();
    if (!formData) return;
    try {
      const checkResponse = await this.sendApiRequest(formData, CONSTANTS.GEN1_API_PATH);
      if (checkResponse.code !== 0) {
        let errorMsg = checkResponse.msg;
        this.showApiError(errorMsg || "提交失败，请稍后重试");
        return false;
      }
      return true;
    } catch (error) {
      console.error("请求错误:", error);
    } finally {
      this.snSubmitBtn.disabled = false;
    }
  }

  // 修改 submitTradeInForm 方法
  async submitTradeInForm() {
    const formData = this.collectFormData();
    if (!formData) return;

    try {
      if (!this.trade_drawer) return;

      const submitButton = this.trade_drawer.querySelector(".trade_button");
      if (submitButton) submitButton.disabled = true;

      const response = await this.sendApiRequest(formData);
      this.handleApiResponse(response);

      // 提交成功后关闭弹窗
      this.trade_drawer.removeAttribute("open");
    } catch (error) {
      console.error("请求错误:", error);
    } finally {
      if (this.trade_drawer) {
        const submitButton = this.trade_drawer.querySelector(".trade_button");
        if (submitButton) submitButton.disabled = false;
      }
    }
  }

  // 添加收集表单数据的辅助方法
  collectFormData() {
    const snInput = this.querySelector('input[name="trade_sn"]');
    if (!snInput) return null;

    return {
      sn: snInput.value.trim(),
      email: this.querySelector('input[type="email"]')?.value || undefined,
      type: Number(this.querySelector('input[name="type"]')?.value) || undefined,
      productId: this.querySelector('input[name="productId"]')?.value || undefined,
      webSite: window?.ShopifyInfo?.webSite || "GB",
    };
  }

  async sendApiRequest(formData, apiPath = CONSTANTS.API_PATH) {
    const payload = {
      client: {
        languageCode: window?.ShopifyInfo?.language || "en",
      },
      payload: {
        businessData: this.encrypted(formData),
      },
    };

    // 判断域名并设置API URL
    const apiDomain = window.location.hostname.includes("test") ? "dev.oms" : "oms";
    const apiUrl = `https://${apiDomain}.gdjztech.com${apiPath}`;

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    return response.json();
  }

  handleApiResponse(data) {
    if (data.code === 0) {
      const { resultData } = data?.payload;
      const decryptedData = this.decrypted(resultData);

      // 检查是否包含折扣码
      if (decryptedData && decryptedData.exchangeCouponCode) {
        // 显示成功UI
        this.showTradeInSuccess(decryptedData);
      }
    } else {
      let errorMsg = data.msg;
      if (data.code == 80100) {
        errorMsg = data.msg + this.querySelector(".tips-error").dataset.msg;
      }
      this.showApiError(errorMsg || "提交失败，请稍后重试");
    }
  }

  showApiError(message = "") {
    const container = this.querySelector(".tips-error .error-message-container");

    // 移除已有的错误消息
    const existingError = container.querySelector(".error-message");
    const error_checkmark = document.querySelector(".trade-in-form .error_checkmark");
    const tips = this.snField.querySelector(".tips");
    if (existingError) {
      existingError.remove();
      error_checkmark.style.display = "none";
    }

    // 创建新的错误消息
    const errorElement = document.createElement("div");
    errorElement.className = "error-message";
    errorElement.setAttribute("data-api-error", "true");
    errorElement.innerHTML = message;
    errorElement.style.display = "block";
    container.appendChild(errorElement);
    if (message != "") {
      error_checkmark.style.display = "inline-block";
      tips.style.display = "none";
    } else {
      error_checkmark.style.display = "none";
      tips.style.display = "block";
    }
  }

  // ===== 成功UI展示方法 =====

  showTradeInSuccess(data) {
    // 隐藏设备列表和输入表单
    this.deviceList.style.display = "none";

    // 显示成功UI
    if (this.successElement) {
      this.updateSuccessUI(data);
      this.setupEditButton();

      // 添加价格计算逻辑
      this.updateProductPrice(data);
    }

    // 隐藏错误信息
  }
  getDiscount() {
    const price = this.querySelector(".select-selected").dataset.price;
    return price?.replace("$", "") || null;
  }
  // 添加价格计算方法
  updateProductPrice(data) {
    this.storeTradeInData(data);
    try {
      // 获取折扣金额
      const tradeInAmount = Number(this.getDiscount());
      document.querySelector('trade-in input[name="tradein-device"]').value = tradeInAmount * 100;
      // 获取原始价格元素
      const initialPriceText = document.querySelector(".rating-with-text sale-price");
      if (!initialPriceText) return;
      const initialPrice = initialPriceText.dataset.price;

      // 检查是否存在 care 选项并且已选中
      const careVariant = document.querySelector('.care-variant[careActive="true"]');
      let finalPrice = Number(initialPrice);
      // 如果有care选项，添加care价格
      if (careVariant) {
        const carePrice = Number(careVariant.dataset?.price || 0);
        finalPrice += carePrice;
      }
      // 减去折扣金额
      finalPrice = finalPrice - tradeInAmount;
      // 更新价格显示
      if (finalPrice >= 0) {
        const salePrice = document.querySelector(
          " .product-info__buy-buttons .buy-bottons_price price-list sale-price",
        );
        salePrice.lastChild.replaceWith(document.createRange().createContextualFragment(getFormattedMoney(finalPrice)));
      }
      document.dispatchEvent(new CustomEvent("tradein:change"));
    } catch (error) {
      console.error("更新价格时出错:", error);
    }
  }

  updateSuccessUI(data) {
    // 更新设备名称
    const deviceName = this.successElement.querySelector(".device-name");
    if (deviceName) deviceName.textContent = this.selectSelected.textContent;

    // 更新折扣金额
    const tradeInValue = this.successElement.querySelector(".trade-in-value");
    if (tradeInValue) {
      tradeInValue.innerHTML = getFormattedMoney(this.getDiscount(), false);
    }

    // 显示成功UI
    this.successElement.style.display = "block";

    // 修改购买按钮
    this.updateBuyButton(data);
  }

  verifyCare() {
    this.scareVariants = document.querySelectorAll(".care-sin");
    const careVariants = document.querySelectorAll(".care-variant");
    if (careVariants.length > 0) {
      const care = Array.from(careVariants).filter((variant) => variant.getAttribute("careactive"));
      const care_variant_erro = document.querySelector(".care-variant-error");
      if (care.length < 1 && care_variant_erro) {
        care_variant_erro.style.display = "block";
        return true;
      }
      return false;
    }
  }
  getSku(sku) {
    const data = CONSTANTS[window?.ShopifyInfo?.shopDomain || window.location.host];
    return data[sku];
  }
  // 添加新方法用于更新购买按钮
  updateBuyButton(data) {
    // 查找原始的购买按钮
    this.originalButton = document.querySelector('.product-info__buy-buttons .button[type="submit"]');
    if (!this.originalButton) return;
    // 创建新的按钮替换原始按钮
    const newButton = document.createElement("button");
    newButton.className = "button button--xl trade-in-button";
    newButton.setAttribute("is", "custom-button");
    newButton.classList.add("trade-in-submit");
    newButton.textContent = this.dataset.buttonText || "buy now";

    // 获取折扣码
    const discountCode = data?.exchangeCouponCode || "";

    // 添加点击事件处理
    newButton.addEventListener("click", async (e) => {
      e.preventDefault();
      if (this.verifyCare()) {
        this.scareVariants.forEach((item) => {
          item.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        });
        return;
      }
      // 获取当前商品ID
      const productForm = document.querySelector('form[action*="/cart/add"]');
      const variantId = productForm?.querySelector('input[name="id"]')?.value;
      const careid = document.querySelector('.care-variant[careActive="true"]')?.dataset?.id || null;
      const sku = document.querySelector('.shopify-product-form input[name="lastSku"]');
      const emailInput = this.querySelector('input[type="email"]');
      const addOn = document.querySelectorAll(".addon-card__checkbox");
      const addonids = [];
      if (addOn.length > 0) {
        addOn.forEach((item) => {
          if (item.checked) {
            addonids.push(item.value + ":1");
          }
        });
      }
      if (!variantId) {
        console.error("无法获取商品变体ID");
        return;
      }
      let variant = `${variantId}:1`;
      if (careid) {
        variant = variant + `,${careid}:1`;
      }

      if (addonids.length > 0) {
        variant = variant + `,${addonids.join(",")}`;
      }
      const skuid = await this.getSku(sku.value);
      if (skuid) {
        variant = variant + `,${skuid}:1`;
      }

      if (discountCode) {
        variant = variant + `?discount=${discountCode}`;
      }
      if (emailInput.value) {
        variant = variant + `&checkout[email]=${emailInput.value}`;
      }
      // 构建购物车URL
      const shopDomain = window.Shopify?.shop || window.location.hostname;
      const cartUrl = `https://${shopDomain}/cart/${variant}`;

      // 跳转到购物车页面
      window.location.href = cartUrl;
    });

    // 替换原始按钮
    this.originalButton.parentNode.replaceChild(newButton, this.originalButton);
  }

  setupEditButton() {
    const editBtn = this.successElement.querySelector(".edit-btn");
    if (editBtn) {
      editBtn.onclick = () => {
        this.handleEditButtonClick();
        this.toggleDeviceList(true);
      };
    }
  }

  handleEditButtonClick() {
    // 隐藏成功UI
    this.successElement.style.display = "none";
    // 重置所有状态
    this.resetAllState();
    // this.selectDeviceBtn.classList.remove("active");
    // this.noTradeInBtn.classList.add("active");
    this.deviceList.classList.remove("active");
    this.deviceList.style.display = "none";
    this.deviceVariant.style.display = "none";
    this.updateProductPrice();
    document.dispatchEvent(new CustomEvent("tradein:change"));
  }

  resetAllState() {
    // 重置表单和选择

    this.resetForm();

    // 清空设备变体数据
    this.deviceVariant.style.display = "none";
    this.deviceVariant.removeAttribute("data-active");
    this.deviceVariant.removeAttribute("data-device");

    // 清空输入框
    this.clearinput();
    // 恢复原始购买按钮
    const tradeInButton = document.querySelector(".trade-in-button");
    if (tradeInButton && this.originalButton) {
      tradeInButton.parentNode.replaceChild(this.originalButton, tradeInButton);
    }
  }
  clearinput() {
    const emailInput = this.querySelector('input[type="email"]');
    this.showApiError("");
    if (emailInput) emailInput.value = "";

    const snInput = this.querySelector('input[name="trade_sn"]');
    if (snInput) snInput.value = "";
    this.emailField.querySelector(".input-field").classList.remove("active");
    this.snField.querySelector(".input-field").classList.remove("active");
  }
  storeTradeInData(data) {
    // 存储折扣码到隐藏字段，以便后续使用
    const tradeinIdInput = this.querySelector('input[name="tradein-device"]');
    if (tradeinIdInput) {
      tradeinIdInput.value = data?.exchangeCouponCode || "";
      tradeinIdInput.dataset.devicePrice = Number(this.getDiscount());
      document.dispatchEvent(new CustomEvent("tradein:change"));
    }
  }

  validateEmailFormat(input) {
    const email = input.value.trim();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid_icon = this.querySelector(".valid-icon");
    // 如果输入为空且不是必填，不显示错误
    if (!email && this.emailField.style.display === "none") {
      return true;
    }

    // 如果输入为空但是必填，显示错误
    if (!email) {
      this.showApiError(this.errorTips?.emptyEmail);
      this.snSubmitBtn.style.display = "none";
      valid_icon.style.display = "none";
      return false;
    }

    // 检查邮箱格式
    if (!emailRegex.test(email)) {
      this.showApiError(this.errorTips?.invalidEmail);
      this.snSubmitBtn.style.display = "none";
      valid_icon.style.display = "none";
      return false;
    }

    // 清除错误提示
    this.removeError();
    this.snSubmitBtn.style.display = "flex";
    valid_icon.style.display = "block";
    return true;
  }

  async validateEmail(input) {
    if (!this.validateEmailFormat(input)) return false;
    const email = input.value.trim();

    try {
      const response = await this.checkEmailInDatabase(email);
      if (!response.exists) {
        this.showApiError(this.errorTips["emailNotFound"]);
        return false;
      }
      this.updateSubmitButtonState();
      return true;
    } catch (error) {
      console.error("Email validation error:", error);
      this.showApiError(this.errorTips["serverError"]);
      return false;
    }
  }

  async validateSN(input) {
    const sn = input.value.trim();
    input.value = sn.replace(/[^a-zA-Z0-9-#]/g, "");
    // 使用简单的 SN 格式验证
    return true;
  }
  validateSNFormat(input) {
    const sn = input.value.trim();

    // 如果输入为空，不显示错误
    if (!sn) {
      return false;
    }

    // 检查格式：只允许字母和数字
    const isValid = /^[A-Za-z0-9]+$/.test(sn);

    if (!isValid) {
      this.showApiError(this.errorTips.snInvalid);
      return false;
    }

    // 清除错误提示
    this.removeError();

    return true;
  }
  removeError() {
    const existingError = this.deviceVariant.querySelector(".error-message");
    if (existingError) {
      existingError.remove();
      const error_checkmark = document.querySelector(".trade-in-form .error_checkmark");
      error_checkmark.style.display = "none";
    }
  }
  // 替换原来的 validateSNFormat 方法
  validateSimpleSNFormat(sn) {
    // 简单验证：非空且只包含字母和数字
    return sn && /^[A-Za-z0-9]+$/.test(sn);
  }

  async checkEmailInDatabase(email) {
    return { exists: true };
  }

  async checkSNUsage(sn) {
    // TODO: Implement API call
    return false;
  }

  resetForm() {
    this.selectSelected.textContent = this.selectSelected.dataset.placeholder;
    this.selectSelected.removeAttribute("data-value");
    this.selectSelected.removeAttribute("data-price");

    if (this.tradeInForm) this.tradeInForm.reset();
  }
}

customElements.define("trade-in", TradeIn);
